import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { ClientNotifier, IBasicCommandResponse } from "../../scripts/ah.mb.client-notifications";
import { IExecuteModelScriptInfo } from "../../entities/nu-model-info";
import { IFileUpload } from "../../entities/file-upload";
import { bootbox } from "../../infrastructure/bootbox-shim";

interface IExecuteScriptResponse extends IBasicCommandResponse {
    failures: string[];
}

@Component
export default class ExecuteScript extends Vue {


    @Prop()
    value: IExecuteModelScriptInfo;

    private userNotifier = new ClientNotifier();
    private busyNotification: string; //Promise<any>;


    filesChange(fileList) {
//        console.log(JSON.stringify(fieldName));
        console.log(JSON.stringify(fileList));

        const formData = new FormData();

        if (!fileList.length) return;

        // append the files to FormData
        Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fileList[x], fileList[x].name);
            });

        // save it
        this.upload(formData);


//        this.files = event.target.files;
//        var anyFiles = this.$refs.myFiles as any;
 //       this.files = anyFiles.files;

  //                   const formEl = <HTMLFormElement>document.getElementById("uploadModelForm");

   //     const formData = new FormData(formEl);
     //   this.formData = formData;
    }

    upload(formData) {

        this.files = new Array<IFileUpload>();

        const url = "/api/1.0/directory/uploadmodel";

        const request = {
            data: formData,
            method: "post",
            headers: {
                'Content-Type': "multipart/form-data"
            }
        };

        return FetchWrapper.fetch(url, request)
            // get data
//            .then(x => x.json())
            .then(x => console.log(x));
    }

    /**
 * Fired after successful upload
 * @param newFile
 * @param oldFile
 */
    inputFile(newFile, oldFile) {
        if (newFile && oldFile/* && newFile.success !== oldFile.success && newFile.success*/) {


            // beforeSend
            this.$emit("scriptExecuting");
            if (newFile.active && !oldFile.active)
                this.busyNotification =  this.userNotifier.showBusyNotification(`Uploading ${this.files[0].name}`);

                //if (newFile.response)

                // success                
            if (newFile.success && !oldFile.success) {

                this.files = [];
                this.userNotifier.clear(this.busyNotification);
                if (newFile.response.success) {
                    // Send info back to parent to refresh tree
                    this.$emit("scriptExecuted", this.value);
                }
                //                else

                var response = newFile.response as IExecuteScriptResponse;
                bootbox.alertDialog(response.response, response.failures.join(";"));

                //this.userNotifier.showCommandResponse(newFile.response);


            }

            }
        }

        mounted() {
        this.files = new Array<IFileUpload>();

    }


//    private files: any[];
    private files: Array<IFileUpload>; 
    data() {
//        @Prop({ default: () => [] })

        return {
            files: this.files
    };

    }

    //computed() {
    //    return {




    //        postAction: () => encodeURI(
    //            `/api/1.0/directory/uploadmodel/${this.value.name}/${this.value.description}/${this.value.category}/${
    //            this.value.path}`),
    //}
    //}

    getSelectedFileName() {
        return this.files.length > 0 ? this.files[0].name : "<no file selected>";
    }


    getPostAction() {

        return encodeURI(
            `/api/1.0/commands/executescript/${this.value.modelId}`);

    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/execute-script-dialog/execute-script-dialog.ts